import { createSelector } from "reselect";

export const revisionTreatmentNavigatorEnabledSelector = createSelector(
  () => false
);
